import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { SocialHabitQty } from '@/types/patient-chart-api';

/**
 * Master data — Social-habit QUANTITY codes for the `historyCode` field
 * in the Social History Add flow (PROD-827 chart write surfaces).
 *
 * Wire (curl-verified by Andrew 2026-05-20):
 *
 *   GET /api/Master/GetSocialHabitQtyList
 *       → SocialHabitQty[]
 *
 * No `searchQuery` parameter — the full list ships in one shot
 * (typical values: Heavy / Moderate / Light / Occasional / High / etc.).
 * Each row carries the PascalCase `Definition` field verbatim — the
 * CreateSocialHistory wire body ships the row VERBATIM.
 *
 * Cached aggressively (15 min) — it's a small static lookup; the QA team
 * almost never adds entries here mid-session.
 */

export function useSocialHabitQtyList(enabled = true) {
  return useQuery({
    queryKey: ['master-social-habit-qty-list'],
    queryFn: ({ signal }) =>
      get<SocialHabitQty[]>('/api/Master/GetSocialHabitQtyList', { signal }),
    enabled,
    staleTime: 15 * 60 * 1000,
  });
}
